import { render } from "./login-logo.vue?vue&type=template&id=5c39fb9e&scoped=true&ts=true"
import script from "./login-logo.vue?vue&type=script&lang=ts"
export * from "./login-logo.vue?vue&type=script&lang=ts"

import "./login-logo.vue?vue&type=style&index=0&id=5c39fb9e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c39fb9e"]])

export default __exports__